/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, Solution} from '@exc/core/src/models/Solution';

const CONFIG: Solution = {
  appId: 'analytics',
  settingsAppId: 'analytics',
  distributionList: ['aaui-service-ops@adobe.com'],
  path: '/analytics',
  serviceCode: 'dma_analytics',
  analytics: {code: 'aa'},
  urlContext: {
    key: 'subOrg',
    config: {
      id: 'global_company_id',
      name: 'login_company',
      preferred: 'is_preferred',
      serviceCode: 'dma_analytics'
    }
  },
  sandbox: {
    hideInitialSpinner: true,
    history: {
      type: HISTORY.SERVER,
      config: {absolutePaths: true}
    },
    ims: {
      client_id: 'SiteCatalyst2',
      scope: 'openid,AdobeID,session,read_organizations,additional_info.job_function,additional_info.user_image_url,additional_info.projectedProductContext,additional_info.roles'
    },
    sources: {
      dev: 'https://localhost.corp.adobe.com:8443/analytics.html',
      qa: {
        discovery: 'https://app-discovery-qe.corp.ethos11-stage-or1.ethos.adobe.net/1.0/unifiedShell',
        payload: ['activeProductContext', 'fullPath', 'imsOrg', 'imsProfile.projectedProductContext', 'path']
      },
      stage: {
        discovery: 'https://app-discovery-qe.corp.ethos11-stage-or1.ethos.adobe.net/1.0/unifiedShell',
        payload: ['activeProductContext', 'fullPath', 'imsOrg', 'imsProfile.projectedProductContext', 'path']
      },
      prod: {
        discovery: 'https://analytics-discovery.adobe.net/1.0/unifiedShell',
        payload: ['activeProductContext', 'fullPath', 'imsOrg', 'imsProfile.projectedProductContext', 'path']
      }
    },
    pageTimeout: 300000
  },
  access: {code: ['dma_analytics']}
};

export default CONFIG;
